export const FETCH_FORM_START = 'src/store/forms/FETCH_FORM_START';
export const FETCH_FORM_SUCCESS = 'src/store/forms/FETCH_FORM_SUCCESS';
export const FETCH_FORM_FAILURE = 'src/store/forms/FETCH_FORM_FAILURE';
export const CLEAR_FORM = 'src/store/forms/CLEAR_FORM';
export const CLEAR_ALL_FORMS = 'src/store/forms/CLEAR_ALL_FORMS';
